module.exports = __webpack_public_path__ + "assets/img/202108-5W.0c03d98f.png";